import {Component, EventEmitter, Input, Output} from "@angular/core";

@Component({
  selector: "confirmation-modal",
  templateUrl: "./confirmation-modal.component.html",
})
export class ConfirmationModalComponent {

  @Input() public question: string = "Are you sure?";
  @Input() public buttonName: string;
  @Input() public show: boolean;
  @Input() public publish: boolean;
  // Deprecated
  @Output() public isConfirmed = new EventEmitter();
  @Output() public onYes = new EventEmitter();
  @Output() public onNo = new EventEmitter();

  public yes() {
    this.isConfirmed.emit(true);
    this.onYes.emit();
    this.show = false;
    this.publish = false;
  }

  public no() {
    this.isConfirmed.emit(false);
    this.onNo.emit();
    this.show = false;
    this.publish = false;
  }

}
